export const desktopMainContainer = {
    fontFamily: 'Lato, sans-serif',
    width: '90%',
    marginLeft: '5%',
    marginRight: "5%"
};

export const  desktopContainerPaper= {
    background: 'transparent'
};

export const desktopContentContainerPaperStyle = {
    borderRadius: '20px',
}

export const desktopContentContainerPaperDivStyle = {
}



// WEBPACK FOOTER //
// ./src/styles/shared/desktop.js